export enum GTMEcommerceAvailability {
    IN_STOCK = "in_stock",
    OUT_OF_STOCK = "out_of_stock"
}
